import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthStore, Helpers, ServiceTicketStore } from '@store';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { TrustHtmlPipe } from '../../../../pipes';
import { LetDirective } from '@ngrx/component';

@Component({
  selector: 'app-service-ticket-arranged-call-result',
  standalone: true,
  imports: [CommonStandaloneModule, LetDirective, MatButtonModule, TrustHtmlPipe],
  templateUrl: './service-ticket-arranged-call-result.component.html',
  styleUrls: ['./service-ticket-arranged-call-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketArrangedCallResultComponent {
  constructor(public authStore: AuthStore, public serviceTicketStore: ServiceTicketStore) {}

  areWorkingHours(time: string): 'yes' | 'after' | 'before' {
    if (Helpers.isCallbackTimeWithinWorkingHours(time, Helpers.callbackTimeDefaultConfig)) {
      return 'yes';
    }

    return +time.substring(0, 2) < 7 ? 'before' : 'after';
  }
}
